// Utility to match frequency values to Shopify selling plan options
export const matchSellingPlan = (plans, frequency) => {
  if (!plans || !plans.length) return null;
  
  console.log('=== SELLING PLAN MATCHER ===');
  console.log('Looking for frequency:', frequency);
  console.log('Available plans:', plans.map(p => ({
    id: p.id,
    name: p.name,
    options: p.options
  })));
  
  // First, try to find by plan index (assuming they're ordered: 15, 30, 45, 60)
  const frequencyToIndex = {
    15: 0,
    30: 1,
    45: 2,
    60: 3
  };
  
  const expectedIndex = frequencyToIndex[frequency];
  if (expectedIndex !== undefined && plans[expectedIndex]) {
    console.log(`Using plan by index position ${expectedIndex} for ${frequency} days:`, plans[expectedIndex].name);
    return plans[expectedIndex].id;
  }
  
  // Common selling plan naming patterns
  const frequencyMap = {
    15: ['15 days', '15 day', '15-day', '15-days', '2 weeks', 'Every 15 days', '2 Weeks', 'Deliver every 2 weeks', '2 Weeks', '15'],
    30: ['30 days', '30 day', '30-day', '30-days', '1 month', 'monthly', 'Every 30 days', 'Every month', '1 Month', 'Month', 'Deliver every 1 month', '30'],
    45: ['45 days', '45 day', '45-day', '45-days', '6 weeks', 'Every 45 days', '6 Weeks', 'Deliver every 6 weeks', '45'],
    60: ['60 days', '60 day', '60-day', '60-days', '2 months', 'Every 60 days', 'Every 2 months', '2 Months', 'Deliver every 2 months', '60'],
  };
  
  const possibleValues = frequencyMap[frequency] || [];
  
  // Try to find exact match first
  for (const plan of plans) {
    for (const option of plan.options || []) {
      // Check if option value matches any of our patterns
      const optionValue = (option.value || '').toLowerCase();
      const optionName = (option.name || '').toLowerCase();
      
      console.log(`  Checking option: ${option.name} = ${option.value}`);
      
      if (possibleValues.some(val => {
        const matches = optionValue.includes(val.toLowerCase()) || 
                       optionName.includes(val.toLowerCase());
        if (matches) {
          console.log(`    ✓ MATCH found for "${val}"`);
        }
        return matches;
      })) {
        console.log(`  Selected plan: ${plan.name} (${plan.id})`);
        return plan.id;
      }
      
      // Also check for numeric matches
      if (optionValue === String(frequency) || 
          optionValue === frequency.toString() ||
          optionValue.includes(`${frequency} day`) ||
          optionValue.includes(`${frequency}day`) ||
          optionValue.includes(`${frequency}`)) {
        console.log(`  Selected plan by numeric match: ${plan.name} (${plan.id})`);
        return plan.id;
      }
    }
  }
  
  // If no match found, let's try a different approach
  console.warn(`No direct match found for frequency ${frequency}`);
  
  // Try to find by plan name containing the number
  const planByName = plans.find(plan => {
    const planName = (plan.name || '').toLowerCase();
    // Extract numbers from plan name
    const numbers = planName.match(/\d+/g);
    const hasMatchingNumber = numbers && numbers.some(num => parseInt(num) === frequency);
    
    return hasMatchingNumber || 
           planName.includes(`${frequency}`) || 
           planName.includes(`${frequency} day`) ||
           planName.includes(`${frequency}-day`);
  });
  
  if (planByName) {
    console.log(`Found plan by name match: ${planByName.name} (${planByName.id})`);
    return planByName.id;
  }
  
  // Try one more approach - look for plans in a specific order
  const orderedFrequencies = [15, 30, 45, 60];
  const freqIndex = orderedFrequencies.indexOf(frequency);
  if (freqIndex !== -1) {
    // Sort plans by name to ensure consistent ordering
    const sortedPlans = [...plans].sort((a, b) => {
      const aNum = parseInt((a.name || '').match(/\d+/)?.[0] || '0');
      const bNum = parseInt((b.name || '').match(/\d+/)?.[0] || '0');
      return aNum - bNum;
    });
    
    if (sortedPlans[freqIndex]) {
      console.log(`Found plan by sorted order: ${sortedPlans[freqIndex].name} (${sortedPlans[freqIndex].id})`);
      return sortedPlans[freqIndex].id;
    }
  }
  
  // Last resort - use first plan
  const fallbackPlan = plans[0];
  if (fallbackPlan) {
    console.log('Using fallback plan:', {
      id: fallbackPlan.id,
      name: fallbackPlan.name,
      options: fallbackPlan.options
    });
  }
  return fallbackPlan?.id || null;
};